export const DashboardSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M4.16667 17.5C3.70833 17.5 3.31583 17.3369 2.98917 17.0108C2.66306 16.6842 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66306 3.31583 2.98917 2.98917C3.31583 2.66306 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.6842 2.66306 17.0108 2.98917C17.3369 3.31583 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3369 16.6842 17.0108 17.0108C16.6842 17.3369 16.2917 17.5 15.8333 17.5H4.16667ZM4.16667 15.8333H9.16667V4.16667H4.16667V15.8333ZM10.8333 15.8333H15.8333V10H10.8333V15.8333ZM10.8333 8.33333H15.8333V4.16667H10.8333V8.33333Z'
        fill=''
      />
    </svg>
  );
};

export const CampaignSvg = () => {
  return (
    <svg
      className='fill-current'
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.5 12.75C15.7333 12.05 14.9877 11.3627 14.263 10.688C13.5377 10.0127 12.896 9.35 12.338 8.7C11.7793 8.05 11.3333 7.42067 11 6.812C10.6667 6.204 10.5 5.61667 10.5 5.05C10.5 4.11667 10.8167 3.33333 11.45 2.7C12.0833 2.06667 12.8667 1.75 13.8 1.75C14.3333 1.75 14.8333 1.86233 15.3 2.087C15.7667 2.31233 16.1667 2.61667 16.5 3C16.8333 2.61667 17.2333 2.31233 17.7 2.087C18.1667 1.86233 18.6667 1.75 19.2 1.75C20.1333 1.75 20.9167 2.06667 21.55 2.7C22.1833 3.33333 22.5 4.11667 22.5 5.05C22.5 5.61667 22.3333 6.204 22 6.812C21.6667 7.42067 21.221 8.05 20.663 8.7C20.1043 9.35 19.4667 10.0127 18.75 10.688C18.0333 11.3627 17.2833 12.05 16.5 12.75ZM16.5 10.05C17.4833 9.11667 18.396 8.18733 19.238 7.262C20.0793 6.33733 20.5 5.6 20.5 5.05C20.5 4.66667 20.3793 4.354 20.138 4.112C19.896 3.87067 19.5833 3.75 19.2 3.75C18.9667 3.75 18.746 3.79567 18.538 3.887C18.3293 3.979 18.15 4.11667 18 4.3L16.5 6.1L15 4.3C14.85 4.11667 14.671 3.979 14.463 3.887C14.2543 3.79567 14.0333 3.75 13.8 3.75C13.4167 3.75 13.1043 3.87067 12.863 4.112C12.621 4.354 12.5 4.66667 12.5 5.05C12.5 5.6 12.9207 6.33733 13.762 7.262C14.604 8.18733 15.5167 9.11667 16.5 10.05ZM14.5 22.25L7.5 20.3V21.75H1.5V10.75H9.45L15.65 13.05C16.2 13.25 16.646 13.6 16.988 14.1C17.3293 14.6 17.5 15.15 17.5 15.75H19.5C20.3333 15.75 21.0417 16.025 21.625 16.575C22.2083 17.125 22.5 17.85 22.5 18.75V19.75L14.5 22.25ZM3.5 19.75H5.5V12.75H3.5V19.75ZM14.45 20.15L20.4 18.3C20.35 18.1167 20.2373 17.979 20.062 17.887C19.8873 17.7957 19.7 17.75 19.5 17.75H14.7C14.1833 17.75 13.7167 17.7167 13.3 17.65C12.8833 17.5833 12.4333 17.4667 11.95 17.3L10.225 16.7L10.8 14.8L12.8 15.45C13.1 15.55 13.45 15.625 13.85 15.675C14.25 15.725 14.8 15.75 15.5 15.75C15.5 15.5667 15.446 15.3917 15.338 15.225C15.2293 15.0583 15.1 14.95 14.95 14.9L9.1 12.75H7.5V18.25L14.45 20.15Z'
        fill=''
      />
    </svg>
  );
};

export const MessagesSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M1.6665 18.3333V3.33333C1.6665 2.875 1.8297 2.48264 2.15609 2.15625C2.48248 1.82986 2.87484 1.66667 3.33317 1.66667H11.7498C11.6943 1.94444 11.6665 2.22222 11.6665 2.5C11.6665 2.77778 11.6943 3.05556 11.7498 3.33333H3.33317V14.2708L4.2915 13.3333H16.6665V6.58333C16.9859 6.51389 17.2846 6.42014 17.5623 6.30208C17.8401 6.18403 18.0971 6.02778 18.3332 5.83333V13.3333C18.3332 13.7917 18.17 14.184 17.8436 14.5104C17.5172 14.8368 17.1248 15 16.6665 15H4.99984L1.6665 18.3333ZM15.8332 5C15.1387 5 14.5484 4.75694 14.0623 4.27083C13.5762 3.78472 13.3332 3.19444 13.3332 2.5C13.3332 1.80556 13.5762 1.21528 14.0623 0.729167C14.5484 0.243056 15.1387 0 15.8332 0C16.5276 0 17.1179 0.243056 17.604 0.729167C18.0901 1.21528 18.3332 1.80556 18.3332 2.5C18.3332 3.19444 18.0901 3.78472 17.604 4.27083C17.1179 4.75694 16.5276 5 15.8332 5Z'
        fill=''
      />
    </svg>
  );
};

export const SearchSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M16.3333 17.5L11.0833 12.25C10.6667 12.5833 10.1875 12.8472 9.64583 13.0417C9.10417 13.2361 8.52778 13.3333 7.91667 13.3333C6.40278 13.3333 5.12153 12.809 4.07292 11.7604C3.02431 10.7118 2.5 9.43056 2.5 7.91667C2.5 6.40278 3.02431 5.12153 4.07292 4.07292C5.12153 3.02431 6.40278 2.5 7.91667 2.5C9.43056 2.5 10.7118 3.02431 11.7604 4.07292C12.809 5.12153 13.3333 6.40278 13.3333 7.91667C13.3333 8.52778 13.2361 9.10417 13.0417 9.64583C12.8472 10.1875 12.5833 10.6667 12.25 11.0833L17.5 16.3333L16.3333 17.5ZM7.91667 11.6667C8.95833 11.6667 9.84375 11.3021 10.5729 10.5729C11.3021 9.84375 11.6667 8.95833 11.6667 7.91667C11.6667 6.875 11.3021 5.98958 10.5729 5.26042C9.84375 4.53125 8.95833 4.16667 7.91667 4.16667C6.875 4.16667 5.98958 4.53125 5.26042 5.26042C4.53125 5.98958 4.16667 6.875 4.16667 7.91667C4.16667 8.95833 4.53125 9.84375 5.26042 10.5729C5.98958 11.3021 6.875 11.6667 7.91667 11.6667Z'
        fill=''
      />
    </svg>
  );
};

export const MedicalSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M11.2498 18.3334C9.74984 18.3334 8.47206 17.8056 7.4165 16.7501C6.36095 15.6945 5.83317 14.4167 5.83317 12.9167V12.4376C4.63873 12.2431 3.64567 11.6841 2.854 10.7605C2.06234 9.83689 1.6665 8.75008 1.6665 7.50008V2.50008H4.1665V1.66675H5.83317V5.00008H4.1665V4.16675H3.33317V7.50008C3.33317 8.41675 3.65956 9.20147 4.31234 9.85425C4.96512 10.507 5.74984 10.8334 6.6665 10.8334C7.58317 10.8334 8.36789 10.507 9.02067 9.85425C9.67345 9.20147 9.99984 8.41675 9.99984 7.50008V4.16675H9.1665V5.00008H7.49984V1.66675H9.1665V2.50008H11.6665V7.50008C11.6665 8.75008 11.2707 9.83689 10.479 10.7605C9.68734 11.6841 8.69428 12.2431 7.49984 12.4376V12.9167C7.49984 13.9584 7.86442 14.8438 8.59359 15.573C9.32275 16.3022 10.2082 16.6667 11.2498 16.6667C12.2915 16.6667 13.1769 16.3022 13.9061 15.573C14.6353 14.8438 14.9998 13.9584 14.9998 12.9167V11.5209C14.5137 11.3542 14.1144 11.0556 13.8019 10.6251C13.4894 10.1945 13.3332 9.70842 13.3332 9.16675C13.3332 8.4723 13.5762 7.88203 14.0623 7.39592C14.5484 6.9098 15.1387 6.66675 15.8332 6.66675C16.5276 6.66675 17.1179 6.9098 17.604 7.39592C18.0901 7.88203 18.3332 8.4723 18.3332 9.16675C18.3332 9.70842 18.1769 10.1945 17.8644 10.6251C17.5519 11.0556 17.1526 11.3542 16.6665 11.5209V12.9167C16.6665 14.4167 16.1387 15.6945 15.0832 16.7501C14.0276 17.8056 12.7498 18.3334 11.2498 18.3334Z'
        fill=''
      />
    </svg>
  );
};

export const MedCentersSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M8.75016 14.1667H11.2502V12.0833H13.3335V9.58333H11.2502V7.5H8.75016V9.58333H6.66683V12.0833H8.75016V14.1667ZM3.3335 17.5V7.5L10.0002 2.5L16.6668 7.5V17.5H3.3335ZM5.00016 15.8333H15.0002V8.33333L10.0002 4.58333L5.00016 8.33333V15.8333Z'
        fill=''
      />
    </svg>
  );
};

export const OrganizationsSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M1.6665 17.4999V3.95825L5.83317 0.833252L9.99984 3.95825V5.83325H18.3332V17.4999H1.6665ZM3.33317 15.8333H4.99984V14.1666H3.33317V15.8333ZM3.33317 12.4999H4.99984V10.8333H3.33317V12.4999ZM3.33317 9.16658H4.99984V7.49992H3.33317V9.16658ZM3.33317 5.83325H4.99984V4.16659H3.33317V5.83325ZM6.6665 5.83325H8.33317V4.16659H6.6665V5.83325ZM6.6665 15.8333H16.6665V7.49992H6.6665V15.8333ZM11.6665 10.8333V9.16658H14.9998V10.8333H11.6665ZM11.6665 14.1666V12.4999H14.9998V14.1666H11.6665ZM8.33317 10.8333V9.16658H9.99984V10.8333H8.33317ZM8.33317 14.1666V12.4999H9.99984V14.1666H8.33317Z'
        fill=''
      />
    </svg>
  );
};

export const MoneySvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M11.6668 10.8333C10.9724 10.8333 10.3821 10.5902 9.896 10.1041C9.40988 9.61797 9.16683 9.0277 9.16683 8.33325C9.16683 7.63881 9.40988 7.04853 9.896 6.56242C10.3821 6.07631 10.9724 5.83325 11.6668 5.83325C12.3613 5.83325 12.9516 6.07631 13.4377 6.56242C13.9238 7.04853 14.1668 7.63881 14.1668 8.33325C14.1668 9.0277 13.9238 9.61797 13.4377 10.1041C12.9516 10.5902 12.3613 10.8333 11.6668 10.8333ZM5.8335 13.3333C5.37516 13.3333 4.98294 13.1699 4.65683 12.8433C4.33016 12.5171 4.16683 12.1249 4.16683 11.6666V4.99992C4.16683 4.54159 4.33016 4.14936 4.65683 3.82325C4.98294 3.49659 5.37516 3.33325 5.8335 3.33325H17.5002C17.9585 3.33325 18.351 3.49659 18.6777 3.82325C19.0038 4.14936 19.1668 4.54159 19.1668 4.99992V11.6666C19.1668 12.1249 19.0038 12.5171 18.6777 12.8433C18.351 13.1699 17.9585 13.3333 17.5002 13.3333H5.8335ZM7.50016 11.6666H15.8335C15.8335 11.2083 15.9966 10.8158 16.3227 10.4891C16.6493 10.163 17.0418 9.99992 17.5002 9.99992V6.66659C17.0418 6.66659 16.6493 6.50325 16.3227 6.17659C15.9966 5.85047 15.8335 5.45825 15.8335 4.99992H7.50016C7.50016 5.45825 7.33683 5.85047 7.01016 6.17659C6.68405 6.50325 6.29183 6.66659 5.8335 6.66659V9.99992C6.29183 9.99992 6.68405 10.163 7.01016 10.4891C7.33683 10.8158 7.50016 11.2083 7.50016 11.6666ZM16.6668 16.6666H2.50016C2.04183 16.6666 1.64961 16.5035 1.3235 16.1774C0.996829 15.8508 0.833496 15.4583 0.833496 14.9999V5.83325H2.50016V14.9999H16.6668V16.6666Z'
        fill=''
      />
    </svg>
  );
};

export const SyncronizeSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M3.3335 16.6666V14.9999H5.62516L5.29183 14.7083C4.56961 14.0694 4.06266 13.3402 3.771 12.5208C3.47933 11.7013 3.3335 10.8749 3.3335 10.0416C3.3335 8.49992 3.7953 7.12839 4.71891 5.927C5.64252 4.72561 6.84738 3.93047 8.3335 3.54159V5.29159C7.3335 5.6527 6.52794 6.26728 5.91683 7.13534C5.30572 8.00339 5.00016 8.97214 5.00016 10.0416C5.00016 10.6666 5.11822 11.2742 5.35433 11.8645C5.59044 12.4548 5.9585 12.9999 6.4585 13.4999L6.66683 13.7083V11.6666H8.3335V16.6666H3.3335ZM11.6668 16.4583V14.7083C12.6668 14.3471 13.4724 13.7326 14.0835 12.8645C14.6946 11.9964 15.0002 11.0277 15.0002 9.95825C15.0002 9.33325 14.8821 8.72561 14.646 8.13534C14.4099 7.54506 14.0418 6.99992 13.5418 6.49992L13.3335 6.29159V8.33325H11.6668V3.33325H16.6668V4.99992H14.3752L14.7085 5.29159C15.3891 5.97214 15.8856 6.71172 16.1981 7.51034C16.5106 8.30895 16.6668 9.12492 16.6668 9.95825C16.6668 11.4999 16.205 12.8714 15.2814 14.0728C14.3578 15.2742 13.1529 16.0694 11.6668 16.4583Z'
        fill=''
      />
    </svg>
  );
};

export const PiggyBankSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M13.3332 9.58325C13.5693 9.58325 13.7671 9.50325 13.9265 9.34325C14.0865 9.18381 14.1665 8.98603 14.1665 8.74992C14.1665 8.51381 14.0865 8.31575 13.9265 8.15575C13.7671 7.99631 13.5693 7.91658 13.3332 7.91658C13.0971 7.91658 12.8993 7.99631 12.7398 8.15575C12.5798 8.31575 12.4998 8.51381 12.4998 8.74992C12.4998 8.98603 12.5798 9.18381 12.7398 9.34325C12.8993 9.50325 13.0971 9.58325 13.3332 9.58325ZM6.6665 7.91658H10.8332V6.24992H6.6665V7.91658ZM3.74984 17.9166C3.27762 16.3333 2.81234 14.7533 2.354 13.1766C1.89567 11.6005 1.6665 9.98603 1.6665 8.33325C1.6665 7.05547 2.11095 5.97214 2.99984 5.08325C3.88873 4.19436 4.97206 3.74992 6.24984 3.74992H10.4165C10.8193 3.22214 11.309 2.81242 11.8857 2.52075C12.4618 2.22909 13.0832 2.08325 13.7498 2.08325C14.0971 2.08325 14.3921 2.20492 14.6348 2.44825C14.8782 2.69103 14.9998 2.98603 14.9998 3.33325C14.9998 3.41659 14.9893 3.49992 14.9682 3.58325C14.9476 3.66659 14.9234 3.74297 14.8957 3.81242C14.8401 3.9652 14.7882 4.12131 14.7398 4.28075C14.6909 4.44075 14.6526 4.60409 14.6248 4.77075L16.5207 6.66658H18.3332V12.4791L15.979 13.2499L14.5832 17.9166H9.99984V16.2499H8.33317V17.9166H3.74984ZM4.99984 16.2499H6.6665V14.5833H11.6665V16.2499H13.3332L14.6248 11.9583L16.6665 11.2708V8.33325H15.8332L12.9165 5.41659C12.9165 5.13881 12.9337 4.87131 12.9682 4.61409C13.0032 4.35742 13.0554 4.09714 13.1248 3.83325C12.7221 3.94436 12.3679 4.1352 12.0623 4.40575C11.7568 4.67686 11.5346 5.01381 11.3957 5.41659H6.24984C5.44428 5.41659 4.75678 5.70131 4.18734 6.27075C3.61789 6.8402 3.33317 7.5277 3.33317 8.33325C3.33317 9.69436 3.52067 11.0241 3.89567 12.3224C4.27067 13.6213 4.63873 14.9305 4.99984 16.2499Z'
        fill=''
      />
    </svg>
  );
};

export const GrantsSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M5 16.4583C3.55556 16.0833 2.36111 15.3056 1.41667 14.125C0.472222 12.9444 0 11.5694 0 10C0 8.43055 0.472222 7.05555 1.41667 5.875C2.36111 4.69444 3.55556 3.91667 5 3.54167V5.29167C4.01389 5.625 3.21181 6.22222 2.59375 7.08333C1.97569 7.94444 1.66667 8.91667 1.66667 10C1.66667 11.0833 1.97569 12.0556 2.59375 12.9167C3.21181 13.7778 4.01389 14.375 5 14.7083V16.4583ZM11.6667 16.6667C9.81944 16.6667 8.24653 16.0174 6.94792 14.7187C5.64931 13.4201 5 11.8472 5 10C5 8.15278 5.64931 6.57986 6.94792 5.28125C8.24653 3.98264 9.81944 3.33333 11.6667 3.33333C12.5833 3.33333 13.4444 3.50694 14.25 3.85417C15.0556 4.20139 15.7639 4.68055 16.375 5.29167L15.2083 6.45833C14.75 6 14.2187 5.64236 13.6146 5.38542C13.0104 5.12847 12.3611 5 11.6667 5C10.2778 5 9.09722 5.48611 8.125 6.45833C7.15278 7.43055 6.66667 8.61111 6.66667 10C6.66667 11.3889 7.15278 12.5694 8.125 13.5417C9.09722 14.5139 10.2778 15 11.6667 15C12.3611 15 13.0104 14.8715 13.6146 14.6146C14.2187 14.3576 14.75 14 15.2083 13.5417L16.375 14.7083C15.7639 15.3194 15.0556 15.7986 14.25 16.1458C13.4444 16.4931 12.5833 16.6667 11.6667 16.6667ZM16.6667 13.3333L15.5 12.1667L16.8333 10.8333H10.8333V9.16667H16.8333L15.5 7.83333L16.6667 6.66667L20 10L16.6667 13.3333Z'
        fill=''
      />
    </svg>
  );
};

export const FilesSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M15.8332 15.8333H6.6665C6.20817 15.8333 5.81581 15.6701 5.48942 15.3438C5.16303 15.0174 4.99984 14.625 4.99984 14.1667V2.5C4.99984 2.04167 5.16303 1.64931 5.48942 1.32292C5.81581 0.996528 6.20817 0.833334 6.6665 0.833334H12.4998L17.4998 5.83333V14.1667C17.4998 14.625 17.3366 15.0174 17.0103 15.3438C16.6839 15.6701 16.2915 15.8333 15.8332 15.8333ZM11.6665 6.66667V2.5H6.6665V14.1667H15.8332V6.66667H11.6665ZM3.33317 19.1667C2.87484 19.1667 2.48248 19.0035 2.15609 18.6771C1.8297 18.3507 1.6665 17.9583 1.6665 17.5V5.83333H3.33317V17.5H12.4998V19.1667H3.33317Z'
        fill=''
      />
    </svg>
  );
};

export const SettingsSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M4.87484 10L4.62484 8.75C4.45817 8.68055 4.30192 8.60764 4.15609 8.53125C4.01025 8.45486 3.86095 8.36111 3.70817 8.25L2.49984 8.625L1.6665 7.20833L2.62484 6.375C2.59706 6.19444 2.58317 6.01389 2.58317 5.83333C2.58317 5.65278 2.59706 5.47222 2.62484 5.29166L1.6665 4.45833L2.49984 3.04166L3.70817 3.41666C3.86095 3.30555 4.01025 3.2118 4.15609 3.13541C4.30192 3.05903 4.45817 2.98611 4.62484 2.91666L4.87484 1.66666H6.5415L6.7915 2.91666C6.95817 2.98611 7.11442 3.05903 7.26025 3.13541C7.40609 3.2118 7.55539 3.30555 7.70817 3.41666L8.9165 3.04166L9.74984 4.45833L8.7915 5.29166C8.81928 5.47222 8.83317 5.65278 8.83317 5.83333C8.83317 6.01389 8.81928 6.19444 8.7915 6.375L9.74984 7.20833L8.9165 8.625L7.70817 8.25C7.55539 8.36111 7.40609 8.45486 7.26025 8.53125C7.11442 8.60764 6.95817 8.68055 6.7915 8.75L6.5415 10H4.87484ZM5.70817 7.5C6.1665 7.5 6.55887 7.3368 6.88525 7.01041C7.21164 6.68402 7.37484 6.29166 7.37484 5.83333C7.37484 5.375 7.21164 4.98264 6.88525 4.65625C6.55887 4.32986 6.1665 4.16666 5.70817 4.16666C5.24984 4.16666 4.85748 4.32986 4.53109 4.65625C4.2047 4.98264 4.0415 5.375 4.0415 5.83333C4.0415 6.29166 4.2047 6.68402 4.53109 7.01041C4.85748 7.3368 5.24984 7.5 5.70817 7.5ZM12.3332 19.1667L11.9582 17.4167C11.7221 17.3333 11.5033 17.2326 11.3019 17.1146C11.1005 16.9965 10.9026 16.8611 10.7082 16.7083L9.0415 17.25L7.87484 15.25L9.20817 14.0833C9.18039 13.8333 9.1665 13.5833 9.1665 13.3333C9.1665 13.0833 9.18039 12.8333 9.20817 12.5833L7.87484 11.4167L9.0415 9.41666L10.7082 9.95833C10.9026 9.80555 11.1005 9.67014 11.3019 9.55208C11.5033 9.43403 11.7221 9.33333 11.9582 9.25L12.3332 7.5H14.6665L15.0415 9.25C15.2776 9.33333 15.4964 9.43403 15.6978 9.55208C15.8991 9.67014 16.0971 9.80555 16.2915 9.95833L17.9582 9.41666L19.1248 11.4167L17.7915 12.5833C17.8193 12.8333 17.8332 13.0833 17.8332 13.3333C17.8332 13.5833 17.8193 13.8333 17.7915 14.0833L19.1248 15.25L17.9582 17.25L16.2915 16.7083C16.0971 16.8611 15.8991 16.9965 15.6978 17.1146C15.4964 17.2326 15.2776 17.3333 15.0415 17.4167L14.6665 19.1667H12.3332ZM13.4998 15.8333C14.1943 15.8333 14.7846 15.5903 15.2707 15.1042C15.7568 14.6181 15.9998 14.0278 15.9998 13.3333C15.9998 12.6389 15.7568 12.0486 15.2707 11.5625C14.7846 11.0764 14.1943 10.8333 13.4998 10.8333C12.8054 10.8333 12.2151 11.0764 11.729 11.5625C11.2429 12.0486 10.9998 12.6389 10.9998 13.3333C10.9998 14.0278 11.2429 14.6181 11.729 15.1042C12.2151 15.5903 12.8054 15.8333 13.4998 15.8333Z'
        fill=''
      />
    </svg>
  );
};

export const ArrowRightSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M9.99992 16.6667L8.81242 15.5L13.4791 10.8333H3.33325V9.16668H13.4791L8.81242 4.50001L9.99992 3.33334L16.6666 10L9.99992 16.6667Z'
        fill=''
      />
    </svg>
  );
};

export const UsersSvg = () => {
  return (
    <svg
      className='fill-current'
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M0.833496 16.6667V14.3333C0.833496 13.8611 0.955024 13.4271 1.19808 13.0313C1.44113 12.6354 1.76405 12.3333 2.16683 12.125C3.02794 11.6944 3.90294 11.3715 4.79183 11.1563C5.68072 10.941 6.5835 10.8333 7.50016 10.8333C8.41683 10.8333 9.31961 10.941 10.2085 11.1563C11.0974 11.3715 11.9724 11.6944 12.8335 12.125C13.2363 12.3333 13.5592 12.6354 13.8022 13.0313C14.0453 13.4271 14.1668 13.8611 14.1668 14.3333V16.6667H0.833496ZM15.8335 16.6667V14.1667C15.8335 13.5556 15.6634 12.9688 15.3231 12.4063C14.9828 11.8438 14.5002 11.3611 13.8752 10.9583C14.5835 11.0417 15.2502 11.184 15.8752 11.3854C16.5002 11.5868 17.0835 11.8333 17.6252 12.125C18.1252 12.4028 18.5071 12.7118 18.771 13.0521C19.0349 13.3924 19.1668 13.7639 19.1668 14.1667V16.6667H15.8335ZM7.50016 10C6.5835 10 5.79877 9.67361 5.146 9.02084C4.49322 8.36806 4.16683 7.58334 4.16683 6.66667C4.16683 5.75 4.49322 4.96528 5.146 4.3125C5.79877 3.65972 6.5835 3.33334 7.50016 3.33334C8.41683 3.33334 9.20155 3.65972 9.85433 4.3125C10.5071 4.96528 10.8335 5.75 10.8335 6.66667C10.8335 7.58334 10.5071 8.36806 9.85433 9.02084C9.20155 9.67361 8.41683 10 7.50016 10ZM15.8335 6.66667C15.8335 7.58334 15.5071 8.36806 14.8543 9.02084C14.2016 9.67361 13.4168 10 12.5002 10C12.3474 10 12.1529 9.98264 11.9168 9.94792C11.6807 9.9132 11.4863 9.875 11.3335 9.83334C11.7085 9.38889 11.9967 8.89584 12.1981 8.35417C12.3995 7.8125 12.5002 7.25 12.5002 6.66667C12.5002 6.08334 12.3995 5.52084 12.1981 4.97917C11.9967 4.4375 11.7085 3.94445 11.3335 3.5C11.5279 3.43056 11.7224 3.38542 11.9168 3.36459C12.1113 3.34375 12.3057 3.33334 12.5002 3.33334C13.4168 3.33334 14.2016 3.65972 14.8543 4.3125C15.5071 4.96528 15.8335 5.75 15.8335 6.66667ZM2.50016 15H12.5002V14.3333C12.5002 14.1806 12.462 14.0417 12.3856 13.9167C12.3092 13.7917 12.2085 13.6944 12.0835 13.625C11.3335 13.25 10.5766 12.9688 9.81266 12.7813C9.04877 12.5938 8.27794 12.5 7.50016 12.5C6.72238 12.5 5.95155 12.5938 5.18766 12.7813C4.42377 12.9688 3.66683 13.25 2.91683 13.625C2.79183 13.6944 2.69113 13.7917 2.61475 13.9167C2.53836 14.0417 2.50016 14.1806 2.50016 14.3333V15ZM7.50016 8.33334C7.9585 8.33334 8.35086 8.17014 8.67725 7.84375C9.00363 7.51736 9.16683 7.125 9.16683 6.66667C9.16683 6.20834 9.00363 5.81597 8.67725 5.48959C8.35086 5.1632 7.9585 5 7.50016 5C7.04183 5 6.64947 5.1632 6.32308 5.48959C5.99669 5.81597 5.8335 6.20834 5.8335 6.66667C5.8335 7.125 5.99669 7.51736 6.32308 7.84375C6.64947 8.17014 7.04183 8.33334 7.50016 8.33334Z'
        fill=''
      />
    </svg>
  );
};

export const FullAccessSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M8 16C6.89333 16 5.85333 15.7899 4.88 15.3696C3.90667 14.9499 3.06 14.38 2.34 13.66C1.62 12.94 1.05013 12.0933 0.6304 11.12C0.210133 10.1467 0 9.10667 0 8C0 6.89333 0.210133 5.85333 0.6304 4.88C1.05013 3.90667 1.62 3.06 2.34 2.34C3.06 1.62 3.90667 1.04987 4.88 0.6296C5.85333 0.209867 6.89333 0 8 0C9.10667 0 10.1467 0.209867 11.12 0.6296C12.0933 1.04987 12.94 1.62 13.66 2.34C14.38 3.06 14.9499 3.90667 15.3696 4.88C15.7899 5.85333 16 6.89333 16 8C16 9.10667 15.7899 10.1467 15.3696 11.12C14.9499 12.0933 14.38 12.94 13.66 13.66C12.94 14.38 12.0933 14.9499 11.12 15.3696C10.1467 15.7899 9.10667 16 8 16Z'
        fill='#00AEB3'
      />
    </svg>
  );
};

export const LimitedAccessSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M8 16C6.90667 16 5.87333 15.7899 4.9 15.3696C3.92667 14.9499 3.0768 14.3765 2.3504 13.6496C1.62347 12.9232 1.05013 12.0733 0.6304 11.1C0.210133 10.1267 0 9.09333 0 8C0 6.89333 0.210133 5.8568 0.6304 4.8904C1.05013 3.92347 1.62347 3.0768 2.3504 2.3504C3.0768 1.62347 3.92667 1.04987 4.9 0.6296C5.87333 0.209867 6.90667 0 8 0C9.10667 0 10.1432 0.209867 11.1096 0.6296C12.0765 1.04987 12.9232 1.62347 13.6496 2.3504C14.3765 3.0768 14.9499 3.92347 15.3696 4.8904C15.7899 5.8568 16 6.89333 16 8C16 9.09333 15.7899 10.1267 15.3696 11.1C14.9499 12.0733 14.3765 12.9232 13.6496 13.6496C12.9232 14.3765 12.0765 14.9499 11.1096 15.3696C10.1432 15.7899 9.10667 16 8 16ZM8 12.8C9.33333 12.8 10.4667 12.3333 11.4 11.4C12.3333 10.4667 12.8 9.33333 12.8 8C12.8 6.66667 12.3333 5.53333 11.4 4.6C10.4667 3.66667 9.33333 3.2 8 3.2C6.66667 3.2 5.53333 3.66667 4.6 4.6C3.66667 5.53333 3.2 6.66667 3.2 8C3.2 9.33333 3.66667 10.4667 4.6 11.4C5.53333 12.3333 6.66667 12.8 8 12.8Z'
        fill='#FEBF3E'
      />
    </svg>
  );
};

export const PrimaryContactSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M13.1833 14C11.5111 14 9.88115 13.6272 8.29344 12.8816C6.70522 12.1364 5.29874 11.1513 4.074 9.926C2.84874 8.70126 1.86356 7.29478 1.11844 5.70656C0.372815 4.11885 0 2.48889 0 0.816667C0 0.583333 0.0777777 0.388889 0.233333 0.233333C0.388889 0.0777777 0.583333 0 0.816667 0H3.96667C4.14815 0 4.31019 0.0583333 4.45278 0.175C4.59537 0.291667 4.67963 0.440741 4.70556 0.622222L5.21111 3.34444C5.23704 3.52593 5.23393 3.69107 5.20178 3.83989C5.16911 3.98922 5.09444 4.12222 4.97778 4.23889L3.09167 6.14444C3.63611 7.07778 4.32004 7.95278 5.14344 8.76944C5.96633 9.58611 6.87037 10.2926 7.85556 10.8889L9.68333 9.06111C9.8 8.94444 9.95245 8.85682 10.1407 8.79822C10.3284 8.74015 10.513 8.72407 10.6944 8.75L13.3778 9.29444C13.5593 9.33333 13.7083 9.4207 13.825 9.55656C13.9417 9.69293 14 9.85185 14 10.0333V13.1833C14 13.4167 13.9222 13.6111 13.7667 13.7667C13.6111 13.9222 13.4167 14 13.1833 14ZM2.35278 4.66667L3.63611 3.38333L3.30556 1.55556H1.575C1.63981 2.08704 1.73056 2.61204 1.84722 3.13056C1.96389 3.64907 2.13241 4.16111 2.35278 4.66667ZM9.31389 11.6278C9.81944 11.8481 10.3349 12.0231 10.8601 12.1528C11.3849 12.2824 11.913 12.3667 12.4444 12.4056V10.6944L10.6167 10.325L9.31389 11.6278Z'
        fill='#131212'
      />
    </svg>
  );
};

export const FundsInquirySvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M9.13118 17.5V15.7083C8.34389 15.5417 7.66445 15.2222 7.09285 14.75C6.52066 14.2778 6.10088 13.6111 5.8335 12.75L7.48234 12.125C7.70515 12.7917 8.03581 13.2986 8.47432 13.6458C8.91223 13.9931 9.48769 14.1667 10.2007 14.1667C10.8097 14.1667 11.3261 14.0383 11.7497 13.7817C12.1728 13.5244 12.3843 13.125 12.3843 12.5833C12.3843 12.0972 12.2209 11.7117 11.8941 11.4267C11.5673 11.1422 10.8097 10.8194 9.62138 10.4583C8.34389 10.0833 7.46748 9.63556 6.99214 9.115C6.5168 8.59389 6.27913 7.95833 6.27913 7.20833C6.27913 6.30556 6.59107 5.60417 7.21496 5.10417C7.83884 4.60417 8.47758 4.31944 9.13118 4.25V2.5H10.9137V4.25C11.6564 4.36111 12.2693 4.61444 12.7524 5.01C13.2349 5.40611 13.5875 5.88889 13.8103 6.45833L12.1615 7.125C11.9832 6.68056 11.7307 6.34722 11.4039 6.125C11.0771 5.90278 10.6315 5.79167 10.067 5.79167C9.41341 5.79167 8.91579 5.92722 8.57414 6.19833C8.23249 6.46889 8.06166 6.80556 8.06166 7.20833C8.06166 7.66667 8.28448 8.02778 8.73011 8.29167C9.17574 8.55556 9.94817 8.83333 11.0474 9.125C12.0724 9.40278 12.8486 9.84361 13.3763 10.4475C13.9033 11.0519 14.1668 11.75 14.1668 12.5417C14.1668 13.5278 13.8549 14.2778 13.231 14.7917C12.6071 15.3056 11.8347 15.625 10.9137 15.75V17.5H9.13118Z'
        fill='#AFC12D'
      />
    </svg>
  );
};

export const FundsRequestSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M3.62522 6.66699V13.3337H2.5V6.66699H3.62522ZM6.28811 9.58366V10.4948H3.33831V9.58366H6.28811ZM6.66019 6.66699V7.58274H3.33831V6.66699H6.66019Z'
        fill='#F47D29'
      />
      <path
        d='M7.55678 6.66699H9.86551C10.3616 6.66699 10.7845 6.7433 11.1342 6.89593C11.4839 7.04856 11.7513 7.27444 11.9366 7.57359C12.1249 7.86968 12.2191 8.23598 12.2191 8.67249C12.2191 9.00521 12.1593 9.29825 12.0397 9.55161C11.9202 9.80497 11.7513 10.0186 11.5332 10.1926C11.315 10.3636 11.055 10.4964 10.7531 10.591L10.4124 10.7604H8.33682L8.32785 9.84923H9.88344C10.1524 9.84923 10.3766 9.80039 10.5559 9.70271C10.7352 9.60503 10.8697 9.47224 10.9594 9.30435C11.052 9.13341 11.0983 8.94111 11.0983 8.72743C11.0983 8.49544 11.0535 8.29398 10.9638 8.12304C10.8772 7.94904 10.7427 7.81626 10.5604 7.72468C10.3781 7.63006 10.1464 7.58274 9.86551 7.58274H8.68201V13.3337H7.55678V6.66699ZM11.2821 13.3337L9.74895 10.3392L10.928 10.3346L12.4836 13.2741V13.3337H11.2821Z'
        fill='#F47D29'
      />
      <path
        d='M14.465 6.66699V13.3337H13.3398V6.66699H14.465ZM17.1279 9.58366V10.4948H14.1781V9.58366H17.1279ZM17.5 6.66699V7.58274H14.1781V6.66699H17.5Z'
        fill='#F47D29'
      />
    </svg>
  );
};

export const EmergencyContactSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M5.65472 14V9.37222L1.69547 11.6861L0.350098 9.33333L4.30935 7L0.350098 4.68611L1.69547 2.33333L5.65472 4.64722V0H8.34547V4.64722L12.3047 2.33333L13.6501 4.68611L9.69085 7L13.6501 9.33333L12.3047 11.6861L8.34547 9.37222V14H5.65472Z'
        fill='#952E46'
      />
    </svg>
  );
};

export const DeleteSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z'
        fill='#F02D3A'
      />
    </svg>
  );
};

export const AccordionToggleSvg = ({ open }) => {
  return (
    <svg
      className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${
        open && 'rotate-180'
      }`}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z'
        fill=''
      />
    </svg>
  );
};

export const CalendarSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.7499 2.9812H14.2874V2.36245C14.2874 2.02495 14.0062 1.71558 13.6405 1.71558C13.2749 1.71558 12.9937 1.99683 12.9937 2.36245V2.9812H4.97803V2.36245C4.97803 2.02495 4.69678 1.71558 4.33115 1.71558C3.96553 1.71558 3.68428 1.99683 3.68428 2.36245V2.9812H2.2499C1.29365 2.9812 0.478027 3.7687 0.478027 4.75308V14.5406C0.478027 15.4968 1.26553 16.3125 2.2499 16.3125H15.7499C16.7062 16.3125 17.5218 15.525 17.5218 14.5406V4.72495C17.5218 3.7687 16.7062 2.9812 15.7499 2.9812ZM1.77178 8.21245H4.1624V10.9968H1.77178V8.21245ZM5.42803 8.21245H8.38115V10.9968H5.42803V8.21245ZM8.38115 12.2625V15.0187H5.42803V12.2625H8.38115ZM9.64678 12.2625H12.5999V15.0187H9.64678V12.2625ZM9.64678 10.9968V8.21245H12.5999V10.9968H9.64678ZM13.8374 8.21245H16.228V10.9968H13.8374V8.21245ZM2.2499 4.24683H3.7124V4.83745C3.7124 5.17495 3.99365 5.48433 4.35928 5.48433C4.7249 5.48433 5.00615 5.20308 5.00615 4.83745V4.24683H13.0499V4.83745C13.0499 5.17495 13.3312 5.48433 13.6968 5.48433C14.0624 5.48433 14.3437 5.20308 14.3437 4.83745V4.24683H15.7499C16.0312 4.24683 16.2562 4.47183 16.2562 4.75308V6.94683H1.77178V4.75308C1.77178 4.47183 1.96865 4.24683 2.2499 4.24683ZM1.77178 14.5125V12.2343H4.1624V14.9906H2.2499C1.96865 15.0187 1.77178 14.7937 1.77178 14.5125ZM15.7499 15.0187H13.8374V12.2625H16.228V14.5406C16.2562 14.7937 16.0312 15.0187 15.7499 15.0187Z'
        fill=''
      />
    </svg>
  );
};

export const ProfileSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.0002 7.79065C11.0814 7.79065 12.7689 6.1594 12.7689 4.1344C12.7689 2.1094 11.0814 0.478149 9.0002 0.478149C6.91895 0.478149 5.23145 2.1094 5.23145 4.1344C5.23145 6.1594 6.91895 7.79065 9.0002 7.79065ZM9.0002 1.7719C10.3783 1.7719 11.5033 2.84065 11.5033 4.16252C11.5033 5.4844 10.3783 6.55315 9.0002 6.55315C7.62207 6.55315 6.49707 5.4844 6.49707 4.16252C6.49707 2.84065 7.62207 1.7719 9.0002 1.7719Z'
        fill=''
      />
      <path
        d='M10.8283 9.05627H7.17207C4.16269 9.05627 1.71582 11.5313 1.71582 14.5406V16.875C1.71582 17.2125 1.99707 17.5219 2.3627 17.5219C2.72832 17.5219 3.00957 17.2407 3.00957 16.875V14.5406C3.00957 12.2344 4.89394 10.3219 7.22832 10.3219H10.8564C13.1627 10.3219 15.0752 12.2063 15.0752 14.5406V16.875C15.0752 17.2125 15.3564 17.5219 15.7221 17.5219C16.0877 17.5219 16.3689 17.2407 16.3689 16.875V14.5406C16.2846 11.5313 13.8377 9.05627 10.8283 9.05627Z'
        fill=''
      />
    </svg>
  );
};

export const TaskListSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_130_9728)'>
        <path
          d='M3.45928 0.984375H1.6874C1.04053 0.984375 0.478027 1.51875 0.478027 2.19375V3.96563C0.478027 4.6125 1.0124 5.175 1.6874 5.175H3.45928C4.10615 5.175 4.66865 4.64063 4.66865 3.96563V2.16562C4.64053 1.51875 4.10615 0.984375 3.45928 0.984375ZM3.3749 3.88125H1.77178V2.25H3.3749V3.88125Z'
          fill=''
        />
        <path
          d='M7.22793 3.71245H16.8748C17.2123 3.71245 17.5217 3.4312 17.5217 3.06558C17.5217 2.69995 17.2404 2.4187 16.8748 2.4187H7.22793C6.89043 2.4187 6.58105 2.69995 6.58105 3.06558C6.58105 3.4312 6.89043 3.71245 7.22793 3.71245Z'
          fill=''
        />
        <path
          d='M3.45928 6.75H1.6874C1.04053 6.75 0.478027 7.28437 0.478027 7.95937V9.73125C0.478027 10.3781 1.0124 10.9406 1.6874 10.9406H3.45928C4.10615 10.9406 4.66865 10.4062 4.66865 9.73125V7.95937C4.64053 7.28437 4.10615 6.75 3.45928 6.75ZM3.3749 9.64687H1.77178V8.01562H3.3749V9.64687Z'
          fill=''
        />
        <path
          d='M16.8748 8.21252H7.22793C6.89043 8.21252 6.58105 8.49377 6.58105 8.8594C6.58105 9.22502 6.86231 9.47815 7.22793 9.47815H16.8748C17.2123 9.47815 17.5217 9.1969 17.5217 8.8594C17.5217 8.5219 17.2123 8.21252 16.8748 8.21252Z'
          fill=''
        />
        <path
          d='M3.45928 12.8531H1.6874C1.04053 12.8531 0.478027 13.3875 0.478027 14.0625V15.8344C0.478027 16.4813 1.0124 17.0438 1.6874 17.0438H3.45928C4.10615 17.0438 4.66865 16.5094 4.66865 15.8344V14.0625C4.64053 13.3875 4.10615 12.8531 3.45928 12.8531ZM3.3749 15.75H1.77178V14.1188H3.3749V15.75Z'
          fill=''
        />
        <path
          d='M16.8748 14.2875H7.22793C6.89043 14.2875 6.58105 14.5687 6.58105 14.9344C6.58105 15.3 6.86231 15.5812 7.22793 15.5812H16.8748C17.2123 15.5812 17.5217 15.3 17.5217 14.9344C17.5217 14.5687 17.2123 14.2875 16.8748 14.2875Z'
          fill=''
        />
      </g>
      <defs>
        <clipPath id='clip0_130_9728'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FormsSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.43425 7.5093H2.278C2.44675 7.5093 2.55925 7.3968 2.58737 7.31243L2.98112 6.32805H5.90612L6.27175 7.31243C6.328 7.48118 6.46862 7.5093 6.58112 7.5093H7.453C7.76237 7.48118 7.87487 7.25618 7.76237 7.03118L5.428 1.4343C5.37175 1.26555 5.3155 1.23743 5.14675 1.23743H3.88112C3.76862 1.23743 3.59987 1.29368 3.57175 1.4343L1.153 7.08743C1.0405 7.2843 1.20925 7.5093 1.43425 7.5093ZM4.47175 2.98118L5.3155 5.17493H3.59987L4.47175 2.98118Z'
        fill=''
      />
      <path
        d='M10.1249 2.5031H16.8749C17.2124 2.5031 17.5218 2.22185 17.5218 1.85623C17.5218 1.4906 17.2405 1.20935 16.8749 1.20935H10.1249C9.7874 1.20935 9.47803 1.4906 9.47803 1.85623C9.47803 2.22185 9.75928 2.5031 10.1249 2.5031Z'
        fill=''
      />
      <path
        d='M16.8749 6.21558H10.1249C9.7874 6.21558 9.47803 6.49683 9.47803 6.86245C9.47803 7.22808 9.75928 7.50933 10.1249 7.50933H16.8749C17.2124 7.50933 17.5218 7.22808 17.5218 6.86245C17.5218 6.49683 17.2124 6.21558 16.8749 6.21558Z'
        fill=''
      />
      <path
        d='M16.875 11.1656H1.77187C1.43438 11.1656 1.125 11.4469 1.125 11.8125C1.125 12.1781 1.40625 12.4594 1.77187 12.4594H16.875C17.2125 12.4594 17.5219 12.1781 17.5219 11.8125C17.5219 11.4469 17.2125 11.1656 16.875 11.1656Z'
        fill=''
      />
      <path
        d='M16.875 16.1156H1.77187C1.43438 16.1156 1.125 16.3969 1.125 16.7625C1.125 17.1281 1.40625 17.4094 1.77187 17.4094H16.875C17.2125 17.4094 17.5219 17.1281 17.5219 16.7625C17.5219 16.3969 17.2125 16.1156 16.875 16.1156Z'
        fill='white'
      />
    </svg>
  );
};

export const TablesSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_130_9756)'>
        <path
          d='M15.7501 0.55835H2.2501C1.29385 0.55835 0.506348 1.34585 0.506348 2.3021V15.8021C0.506348 16.7584 1.29385 17.574 2.27822 17.574H15.7782C16.7345 17.574 17.5501 16.7865 17.5501 15.8021V2.3021C17.522 1.34585 16.7063 0.55835 15.7501 0.55835ZM6.69385 10.599V6.4646H11.3063V10.5709H6.69385V10.599ZM11.3063 11.8646V16.3083H6.69385V11.8646H11.3063ZM1.77197 6.4646H5.45635V10.5709H1.77197V6.4646ZM12.572 6.4646H16.2563V10.5709H12.572V6.4646ZM2.2501 1.82397H15.7501C16.0313 1.82397 16.2563 2.04897 16.2563 2.33022V5.2271H1.77197V2.3021C1.77197 2.02085 1.96885 1.82397 2.2501 1.82397ZM1.77197 15.8021V11.8646H5.45635V16.3083H2.2501C1.96885 16.3083 1.77197 16.0834 1.77197 15.8021ZM15.7501 16.3083H12.572V11.8646H16.2563V15.8021C16.2563 16.0834 16.0313 16.3083 15.7501 16.3083Z'
          fill=''
        />
      </g>
      <defs>
        <clipPath id='clip0_130_9756'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(0 0.052124)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PagesSvg = () => {
  return (
    <svg
      className='fill-current'
      width='16'
      height='18'
      viewBox='0 0 16 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.2875 0.506226H2.7125C1.75625 0.506226 0.96875 1.29373 0.96875 2.24998V15.75C0.96875 16.7062 1.75625 17.5219 2.74063 17.5219H13.3156C14.2719 17.5219 15.0875 16.7344 15.0875 15.75V2.24998C15.0313 1.29373 14.2438 0.506226 13.2875 0.506226ZM13.7656 15.75C13.7656 16.0312 13.5406 16.2562 13.2594 16.2562H2.7125C2.43125 16.2562 2.20625 16.0312 2.20625 15.75V2.24998C2.20625 1.96873 2.43125 1.74373 2.7125 1.74373H13.2875C13.5688 1.74373 13.7938 1.96873 13.7938 2.24998V15.75H13.7656Z'
        fill=''
      />
      <path
        d='M11.7965 2.6156H8.73086C8.22461 2.6156 7.80273 3.03748 7.80273 3.54373V7.25623C7.80273 7.76248 8.22461 8.18435 8.73086 8.18435H11.7965C12.3027 8.18435 12.7246 7.76248 12.7246 7.25623V3.5156C12.6965 3.03748 12.3027 2.6156 11.7965 2.6156ZM11.4309 6.8906H9.06836V3.88123H11.4309V6.8906Z'
        fill=''
      />
      <path
        d='M3.97773 4.35938H6.03086C6.36836 4.35938 6.67773 4.07812 6.67773 3.7125C6.67773 3.34687 6.39648 3.09375 6.03086 3.09375H3.94961C3.61211 3.09375 3.30273 3.375 3.30273 3.74063C3.30273 4.10625 3.61211 4.35938 3.97773 4.35938Z'
        fill=''
      />
      <path
        d='M3.97773 7.9312H6.03086C6.36836 7.9312 6.67773 7.64995 6.67773 7.28433C6.67773 6.9187 6.39648 6.63745 6.03086 6.63745H3.94961C3.61211 6.63745 3.30273 6.9187 3.30273 7.28433C3.30273 7.64995 3.61211 7.9312 3.97773 7.9312Z'
        fill=''
      />
      <path
        d='M12.0789 10.2374H3.97891C3.64141 10.2374 3.33203 10.5187 3.33203 10.8843C3.33203 11.2499 3.61328 11.5312 3.97891 11.5312H12.0789C12.4164 11.5312 12.7258 11.2499 12.7258 10.8843C12.7258 10.5187 12.4164 10.2374 12.0789 10.2374Z'
        fill=''
      />
      <path
        d='M12.0789 13.8093H3.97891C3.64141 13.8093 3.33203 14.0906 3.33203 14.4562C3.33203 14.8218 3.61328 15.1031 3.97891 15.1031H12.0789C12.4164 15.1031 12.7258 14.8218 12.7258 14.4562C12.7258 14.0906 12.4164 13.8093 12.0789 13.8093Z'
        fill=''
      />
    </svg>
  );
};

export const MessageSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.7499 2.75208H2.2499C1.29365 2.75208 0.478027 3.53957 0.478027 4.52395V13.6364C0.478027 14.5927 1.26553 15.4083 2.2499 15.4083H15.7499C16.7062 15.4083 17.5218 14.6208 17.5218 13.6364V4.49583C17.5218 3.53958 16.7062 2.75208 15.7499 2.75208ZM15.7499 4.0177C15.778 4.0177 15.8062 4.0177 15.8343 4.0177L8.9999 8.4052L2.16553 4.0177C2.19365 4.0177 2.22178 4.0177 2.2499 4.0177H15.7499ZM15.7499 14.0865H2.2499C1.96865 14.0865 1.74365 13.8615 1.74365 13.5802V5.2552L8.3249 9.47395C8.52178 9.61457 8.74678 9.67083 8.97178 9.67083C9.19678 9.67083 9.42178 9.61457 9.61865 9.47395L16.1999 5.2552V13.6083C16.2562 13.8896 16.0312 14.0865 15.7499 14.0865Z'
        fill=''
      />
    </svg>
  );
};

export const InboxSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.8749 7.44902C16.5374 7.44902 16.228 7.73027 16.228 8.0959V13.3834C16.228 14.4803 15.4124 15.3521 14.3999 15.3521H3.5999C2.55928 15.3521 1.77178 14.4803 1.77178 13.3834V8.06777C1.77178 7.73027 1.49053 7.4209 1.1249 7.4209C0.759277 7.4209 0.478027 7.70215 0.478027 8.06777V13.3553C0.478027 15.1271 1.85615 16.5896 3.57178 16.5896H14.3999C16.1155 16.5896 17.4937 15.1553 17.4937 13.3553V8.06777C17.5218 7.73027 17.2124 7.44902 16.8749 7.44902Z'
        fill=''
      />
      <path
        d='M8.5498 11.6396C8.6623 11.7521 8.83105 11.8365 8.9998 11.8365C9.16855 11.8365 9.30918 11.7803 9.4498 11.6396L12.8811 8.23652C13.1342 7.9834 13.1342 7.58965 12.8811 7.33652C12.6279 7.0834 12.2342 7.0834 11.9811 7.33652L9.64668 9.64277V2.16152C9.64668 1.82402 9.36543 1.51465 8.9998 1.51465C8.6623 1.51465 8.35293 1.7959 8.35293 2.16152V9.69902L6.01855 7.36465C5.76543 7.11152 5.37168 7.11152 5.11855 7.36465C4.86543 7.61777 4.86543 8.01152 5.11855 8.26465L8.5498 11.6396Z'
        fill=''
      />
    </svg>
  );
};

export const InvoiceSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_130_9787)'>
        <path
          d='M15.8343 2.49902C15.8343 1.43027 14.9624 0.530273 13.8655 0.530273H4.13428C3.06553 0.530273 2.16553 1.40215 2.16553 2.49902V16.6178C2.16553 16.8428 2.30615 17.0678 2.50303 17.1803C2.6999 17.2928 2.95303 17.2646 3.1499 17.1521L4.55615 16.224L6.44053 17.4615C6.66553 17.6021 6.91865 17.6021 7.14365 17.4615L8.9999 16.224L10.8562 17.4615C10.9687 17.5459 11.0812 17.574 11.1937 17.574C11.3062 17.574 11.4468 17.5459 11.5312 17.4615L13.3874 16.224L14.7937 17.1803C14.9905 17.3209 15.2437 17.3209 15.4405 17.2084C15.6374 17.0959 15.778 16.8709 15.778 16.6459L15.8343 2.49902ZM14.0343 15.099C13.6687 14.8459 13.1905 14.8459 12.8249 15.099L11.2218 16.1678L9.61865 15.099C9.42178 14.9865 9.2249 14.9021 8.9999 14.9021C8.80303 14.9021 8.57803 14.9584 8.40928 15.099L6.80615 16.1678L5.20303 15.099C4.8374 14.8459 4.35928 14.8459 3.99365 15.099L3.45928 15.4365V2.49902C3.45928 2.10527 3.76865 1.7959 4.1624 1.7959H13.9218C14.3155 1.7959 14.6249 2.10527 14.6249 2.49902V15.4365L14.0343 15.099Z'
          fill=''
        />
        <path
          d='M7.93106 3.79272H5.5123C5.1748 3.79272 4.89355 4.07397 4.89355 4.41147C4.89355 4.74897 5.1748 5.03022 5.5123 5.03022H7.93106C8.26856 5.03022 8.54981 4.74897 8.54981 4.41147C8.54981 4.07397 8.26856 3.79272 7.93106 3.79272Z'
          fill=''
        />
        <path
          d='M12.347 3.79272H11.672C11.3345 3.79272 11.0532 4.07397 11.0532 4.41147C11.0532 4.74897 11.3345 5.03022 11.672 5.03022H12.347C12.6845 5.03022 12.9657 4.74897 12.9657 4.41147C12.9657 4.07397 12.6845 3.79272 12.347 3.79272Z'
          fill=''
        />
        <path
          d='M5.5123 8.74275H7.05918C7.39668 8.74275 7.67793 8.4615 7.67793 8.124C7.67793 7.7865 7.39668 7.50525 7.05918 7.50525H5.5123C5.1748 7.50525 4.89355 7.7865 4.89355 8.124C4.89355 8.4615 5.14668 8.74275 5.5123 8.74275Z'
          fill=''
        />
        <path
          d='M12.347 7.47717H11.672C11.3345 7.47717 11.0532 7.75842 11.0532 8.09592C11.0532 8.43342 11.3345 8.71467 11.672 8.71467H12.347C12.6845 8.71467 12.9657 8.43342 12.9657 8.09592C12.9657 7.75842 12.6845 7.47717 12.347 7.47717Z'
          fill=''
        />
        <path
          d='M7.93106 11.1334H5.5123C5.1748 11.1334 4.89355 11.4147 4.89355 11.7522C4.89355 12.0897 5.1748 12.3709 5.5123 12.3709H7.93106C8.26856 12.3709 8.54981 12.0897 8.54981 11.7522C8.54981 11.4147 8.26856 11.1334 7.93106 11.1334Z'
          fill=''
        />
        <path
          d='M12.347 11.1334H11.672C11.3345 11.1334 11.0532 11.4147 11.0532 11.7522C11.0532 12.0897 11.3345 12.3709 11.672 12.3709H12.347C12.6845 12.3709 12.9657 12.0897 12.9657 11.7522C12.9657 11.4147 12.6845 11.1334 12.347 11.1334Z'
          fill=''
        />
      </g>
      <defs>
        <clipPath id='clip0_130_9787'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(0 0.052124)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ChartSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1184_13869)'>
        <path
          d='M10.8559 0.506226C10.5184 0.506226 10.209 0.787476 10.209 1.1531V6.7781C10.209 7.1156 10.4902 7.42498 10.8559 7.42498H16.8746C17.0434 7.42498 17.2121 7.3406 17.3246 7.2281C17.4371 7.08748 17.4934 6.91873 17.4934 6.74998C17.2684 3.23435 14.3434 0.506226 10.8559 0.506226ZM11.4746 6.1031V1.79998C13.809 2.08123 15.6934 3.82498 16.1434 6.13123H11.4746V6.1031Z'
          fill=''
        />
        <path
          d='M15.384 8.69057H9.11211V2.6437C9.11211 2.3062 8.83086 2.02495 8.49336 2.02495C8.40898 2.02495 8.32461 2.02495 8.24023 2.02495C3.96523 1.99682 0.505859 5.48432 0.505859 9.75932C0.505859 14.0343 3.99336 17.5218 8.26836 17.5218C12.5434 17.5218 16.0309 14.0343 16.0309 9.75932C16.0309 9.59057 16.0309 9.42182 16.0027 9.2812C16.0027 8.9437 15.7215 8.69057 15.384 8.69057ZM8.26836 16.2562C4.66836 16.2562 1.77148 13.3593 1.77148 9.75932C1.77148 6.32807 4.47148 3.48745 7.87461 3.29057V9.30932C7.87461 9.64682 8.15586 9.9562 8.52148 9.9562H14.7934C14.6809 13.4437 11.784 16.2562 8.26836 16.2562Z'
          fill=''
        />
      </g>
      <defs>
        <clipPath id='clip0_1184_13869'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UIElementsSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_130_9807)'>
        <path
          d='M15.7501 0.55835H2.2501C1.29385 0.55835 0.506348 1.34585 0.506348 2.3021V7.53335C0.506348 8.4896 1.29385 9.2771 2.2501 9.2771H15.7501C16.7063 9.2771 17.4938 8.4896 17.4938 7.53335V2.3021C17.4938 1.34585 16.7063 0.55835 15.7501 0.55835ZM16.2563 7.53335C16.2563 7.8146 16.0313 8.0396 15.7501 8.0396H2.2501C1.96885 8.0396 1.74385 7.8146 1.74385 7.53335V2.3021C1.74385 2.02085 1.96885 1.79585 2.2501 1.79585H15.7501C16.0313 1.79585 16.2563 2.02085 16.2563 2.3021V7.53335Z'
          fill=''
        />
        <path
          d='M6.13135 10.9646H2.2501C1.29385 10.9646 0.506348 11.7521 0.506348 12.7083V15.8021C0.506348 16.7583 1.29385 17.5458 2.2501 17.5458H6.13135C7.0876 17.5458 7.8751 16.7583 7.8751 15.8021V12.7083C7.90322 11.7521 7.11572 10.9646 6.13135 10.9646ZM6.6376 15.8021C6.6376 16.0833 6.4126 16.3083 6.13135 16.3083H2.2501C1.96885 16.3083 1.74385 16.0833 1.74385 15.8021V12.7083C1.74385 12.4271 1.96885 12.2021 2.2501 12.2021H6.13135C6.4126 12.2021 6.6376 12.4271 6.6376 12.7083V15.8021Z'
          fill=''
        />
        <path
          d='M15.75 10.9646H11.8688C10.9125 10.9646 10.125 11.7521 10.125 12.7083V15.8021C10.125 16.7583 10.9125 17.5458 11.8688 17.5458H15.75C16.7063 17.5458 17.4938 16.7583 17.4938 15.8021V12.7083C17.4938 11.7521 16.7063 10.9646 15.75 10.9646ZM16.2562 15.8021C16.2562 16.0833 16.0312 16.3083 15.75 16.3083H11.8688C11.5875 16.3083 11.3625 16.0833 11.3625 15.8021V12.7083C11.3625 12.4271 11.5875 12.2021 11.8688 12.2021H15.75C16.0312 12.2021 16.2562 12.4271 16.2562 12.7083V15.8021Z'
          fill=''
        />
      </g>
      <defs>
        <clipPath id='clip0_130_9807'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(0 0.052124)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AuthenticationSvg = () => {
  return (
    <svg
      className='fill-current'
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_130_9814)'>
        <path
          d='M12.7127 0.55835H9.53457C8.80332 0.55835 8.18457 1.1771 8.18457 1.90835V3.84897C8.18457 4.18647 8.46582 4.46772 8.80332 4.46772C9.14082 4.46772 9.45019 4.18647 9.45019 3.84897V1.88022C9.45019 1.82397 9.47832 1.79585 9.53457 1.79585H12.7127C13.3877 1.79585 13.9221 2.33022 13.9221 3.00522V15.0709C13.9221 15.7459 13.3877 16.2802 12.7127 16.2802H9.53457C9.47832 16.2802 9.45019 16.2521 9.45019 16.1959V14.2552C9.45019 13.9177 9.16894 13.6365 8.80332 13.6365C8.43769 13.6365 8.18457 13.9177 8.18457 14.2552V16.1959C8.18457 16.9271 8.80332 17.5459 9.53457 17.5459H12.7127C14.0908 17.5459 15.1877 16.4209 15.1877 15.0709V3.03335C15.1877 1.65522 14.0627 0.55835 12.7127 0.55835Z'
          fill=''
        />
        <path
          d='M10.4346 8.60205L7.62207 5.7333C7.36895 5.48018 6.97519 5.48018 6.72207 5.7333C6.46895 5.98643 6.46895 6.38018 6.72207 6.6333L8.46582 8.40518H3.45957C3.12207 8.40518 2.84082 8.68643 2.84082 9.02393C2.84082 9.36143 3.12207 9.64268 3.45957 9.64268H8.49395L6.72207 11.4427C6.46895 11.6958 6.46895 12.0896 6.72207 12.3427C6.83457 12.4552 7.00332 12.5114 7.17207 12.5114C7.34082 12.5114 7.50957 12.4552 7.62207 12.3145L10.4346 9.4458C10.6877 9.24893 10.6877 8.85518 10.4346 8.60205Z'
          fill=''
        />
      </g>
      <defs>
        <clipPath id='clip0_130_9814'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(0 0.052124)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
